import { Box, Chip } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { tagsService, contrastText } from '../services/tags.service';

/**
 * Renders an entity's tags (resolved from tag ids) as coloured chips — for use in a
 * DataGrid `renderCell`. Shares the app-wide ['tags'] query cache (populated by
 * TagSelect), so it costs no extra request on pages that already load tags.
 */
export default function TagChips({ ids }: { ids?: string[] }) {
  const { data } = useQuery({ queryKey: ['tags'], queryFn: () => tagsService.query() });
  if (!ids || ids.length === 0) return null;
  const tags = data?.data ?? [];
  const resolved = ids
    .map((id) => tags.find((t) => t.id === id))
    .filter((t): t is NonNullable<typeof t> => !!t);
  if (resolved.length === 0) return null;
  return (
    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap', overflow: 'hidden', alignItems: 'center', height: '100%' }}>
      {resolved.map((t) => (
        <Chip
          key={t.id}
          label={t.name}
          size="small"
          sx={{ bgcolor: t.color, color: contrastText(t.color || '#607d8b'), fontWeight: 500, height: 20 }}
        />
      ))}
    </Box>
  );
}
